export default "__VITE_ASSET__uYD97iiL1i0IH__9K2gHUA__";